import getLocalString from "constants/Localization";
import { useDeleteOrganizationProposalChecklistItemMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteOrganizationProposalChecklistItem() {
  const [mutation, { loading, data, error }] = useDeleteOrganizationProposalChecklistItemMutation({
    refetchQueries: ["organizationProposalChecklistItems"],
  });

  const [deleteOrganizationProposalChecklistItem, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteOrganizationProposalChecklistItem",
    },
    {
      successMessage: getLocalString("organization.delete-checklist-item-success"),
      failureMessage: getLocalString("organization.delete-checklist-item-failure"),
    }
  );

  return [deleteOrganizationProposalChecklistItem, context] as const;
}
